<div class="ion-padding hnp">
  <div class="hnp-fej">
    <h2><ion-icon name="eye-outline"></ion-icon> Hozzáférési napló</h2>
    <ion-button size="small" fill="outline" (click)="betolt(oldal); allapotBetolt()" [disabled]="fut">
      <ion-icon slot="start" name="refresh-outline"></ion-icon>Frissítés
    </ion-button>
  </div>
  <p class="hnp-halvany">
    Ki, mikor, melyik tanulói, szülői vagy dolgozói adatot kiszolgáló képernyőt, végpontot hívta (GDPR 32. cikk).
    Nézetváltásnál („belépés más nevében") a valódi kérő is látszik. Az útvonalból a lekérdezési paraméterek és a
    kulcsok (pl. az adatexport-címek kulcsa) kimaradnak. A tanuló azonosítója ott szerepel, ahol a kérésből
    kiolvasható. A sorok {{ allapot?.megorzes_nap || 365 }} napig maradnak meg.
  </p>

  <div class="hnp-figyelem" role="note" *ngIf="allapot && !allapot.bekapcsolva">
    <ion-icon name="warning-outline"></ion-icon>
    <div><b>A naplózás ki van kapcsolva</b> ezen a kiszolgálón (<code>HOZZAFERES_NAPLO=0</code>). Új sor nem keletkezik.</div>
  </div>
  <div class="hnp-figyelem" role="note" *ngIf="allapot && (allapot.eldobott > 0 || allapot.hibak > 0)">
    <ion-icon name="warning-outline"></ion-icon>
    <div>
      <span *ngIf="allapot.eldobott > 0">A kiszolgáló indulása óta <b>{{ allapot.eldobott }}</b> naplósor elveszett, mert
        a kiírás nem győzte (túlcsordult a várakozó sor). </span>
      <span *ngIf="allapot.hibak > 0">Kiírási hiba: {{ allapot.hibak }} alkalommal<span *ngIf="allapot.utolsoHiba">
        (utoljára {{ allapot.utolsoHibaIdo | slice:0:16 }}: {{ allapot.utolsoHiba }})</span>.</span>
    </div>
  </div>

  <!-- SZŰRŐK -->
  <form class="hnp-kartya hnp-szurok" (ngSubmit)="szur()">
    <label class="hnp-mezo">Felhasználó
      <input type="text" name="felhasznalo" [(ngModel)]="felhasznalo" placeholder="felhasználónév (részlet)" autocomplete="off">
    </label>
    <label class="hnp-mezo">Tanuló
      <input type="text" name="tanulo" [(ngModel)]="tanulo" placeholder="oktatási azonosító vagy név" autocomplete="off">
    </label>
    <label class="hnp-mezo">Ettől
      <input type="date" name="tol" [(ngModel)]="tol">
    </label>
    <label class="hnp-mezo">Eddig
      <input type="date" name="ig" [(ngModel)]="ig">
    </label>
    <label class="hnp-mezo">Útvonal
      <input type="text" name="utvonal" [(ngModel)]="utvonal" placeholder="pl. /of/ vagy szakertoi" autocomplete="off">
    </label>
    <label class="hnp-mezo">Művelet
      <select name="modszer" [(ngModel)]="modszer">
        <option value="">mind</option>
        <option value="GET">megtekintés (GET)</option>
        <option value="POST">küldés (POST)</option>
        <option value="PUT">módosítás (PUT)</option>
        <option value="PATCH">módosítás (PATCH)</option>
        <option value="DELETE">törlés (DELETE)</option>
      </select>
    </label>
    <label class="hnp-mezo">Válasz
      <select name="statusz" [(ngModel)]="statusz">
        <option value="">mind</option>
        <option value="ok">sikeres</option>
        <option value="hiba">elutasított / hibás</option>
      </select>
    </label>
    <label class="hnp-jelolo">
      <input type="checkbox" name="nezetvaltas" [(ngModel)]="csakNezetvaltas"> csak nézetváltásban
    </label>
    <div class="hnp-gombok">
      <ion-button size="small" type="submit" [disabled]="fut"><ion-icon slot="start" name="search-outline"></ion-icon>Szűrés</ion-button>
      <ion-button size="small" fill="clear" type="button" (click)="torol()" [disabled]="fut">Szűrők törlése</ion-button>
    </div>
  </form>

  <ion-note color="danger" class="hnp-hiba" *ngIf="hiba">{{ hiba }}</ion-note>

  <section class="hnp-kartya" *ngIf="betoltve">
    <div class="hnp-kartya-fej">
      <h3>{{ osszes }} bejegyzés</h3>
      <div class="hnp-lapozo" *ngIf="osszes > meret">
        <ion-button size="small" fill="clear" (click)="lapoz(-1)" [disabled]="fut || oldal <= 1" aria-label="Előző oldal">
          <ion-icon name="chevron-back-outline"></ion-icon></ion-button>
        <span>{{ oldal }} / {{ oldalak }}</span>
        <ion-button size="small" fill="clear" (click)="lapoz(1)" [disabled]="fut || oldal >= oldalak" aria-label="Következő oldal">
          <ion-icon name="chevron-forward-outline"></ion-icon></ion-button>
      </div>
    </div>
    <div class="hnp-halvany" *ngIf="!sorok.length">Ebben a szűrésben nincs bejegyzés.</div>
    <div class="hnp-tabla-wrap" *ngIf="sorok.length">
      <table class="hnp-tabla">
        <thead>
          <tr><th>Időpont</th><th>Felhasználó</th><th>Tanuló</th><th>Művelet</th><th>Útvonal</th><th class="szam">Válasz</th><th>IP</th></tr>
        </thead>
        <tbody>
          <tr *ngFor="let s of sorok">
            <td class="hnp-ido">{{ s.idopont }}</td>
            <td>
              <button type="button" class="hnp-link" *ngIf="s.felhasznalo; else azonositatlan" (click)="szurFelhasznalo(s.felhasznalo)"
                      [title]="'Szűrés erre: ' + s.felhasznalo">{{ s.felhasznalo_nev || s.felhasznalo }}</button>
              <ng-template #azonositatlan><span class="hnp-halvany">azonosítatlan</span></ng-template>
              <div class="hnp-kicsi hnp-halvany" *ngIf="s.felhasznalo_nev">{{ s.felhasznalo }}{{ s.felhasznalo_szerep ? ' · ' + s.felhasznalo_szerep : '' }}</div>
              <div class="hnp-kicsi hnp-nezet" *ngIf="s.valodi_felhasznalo">
                <ion-icon name="swap-horizontal-outline"></ion-icon>
                nézetváltás – valójában:
                <button type="button" class="hnp-link" (click)="szurFelhasznalo(s.valodi_felhasznalo)">{{ s.valodi_nev || s.valodi_felhasznalo }}</button>
              </div>
            </td>
            <td>
              <button type="button" class="hnp-link" *ngIf="s.tanulo; else nincsTanulo" (click)="szurTanulo(s.tanulo)"
                      [title]="'Szűrés erre: ' + s.tanulo">{{ s.tanulo_nev || s.tanulo }}</button>
              <ng-template #nincsTanulo><span class="hnp-halvany">—</span></ng-template>
              <div class="hnp-kicsi hnp-halvany" *ngIf="s.tanulo_nev">{{ s.tanulo }}</div>
            </td>
            <td><span class="hnp-modszer">{{ s.modszer }}</span></td>
            <td class="hnp-ut">
              <code>{{ s.utvonal }}</code>
              <div class="hnp-kicsi hnp-halvany" *ngIf="s.sablon && s.sablon !== s.utvonal">{{ s.sablon }}</div>
            </td>
            <td class="szam">
              <span class="hnp-statusz" [ngClass]="statuszOsztaly(s.statusz)">{{ s.statusz || 'megszakadt' }}</span>
              <div class="hnp-kicsi hnp-halvany" *ngIf="s.ido_ms != null">{{ s.ido_ms }} ms</div>
            </td>
            <td class="hnp-kicsi">{{ s.ip || '—' }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="hnp-lapozo hnp-lapozo-also" *ngIf="osszes > meret">
      <ion-button size="small" fill="clear" (click)="lapoz(-1)" [disabled]="fut || oldal <= 1">Előző</ion-button>
      <span>{{ oldal }} / {{ oldalak }}</span>
      <ion-button size="small" fill="clear" (click)="lapoz(1)" [disabled]="fut || oldal >= oldalak">Következő</ion-button>
    </div>
  </section>

  <section class="hnp-kartya" *ngIf="allapot">
    <button type="button" class="hnp-osszecsuk" (click)="utvonalakNyitva = !utvonalakNyitva" [attr.aria-expanded]="utvonalakNyitva">
      <ion-icon [name]="utvonalakNyitva ? 'chevron-down-outline' : 'chevron-forward-outline'"></ion-icon>
      Mely útvonalak kerülnek a naplóba?
    </button>
    <div *ngIf="utvonalakNyitva">
      <p class="hnp-halvany">
        A személyes adatot kiszolgáló útvonalak (az első szegmens, a <code>/api</code> előtag nélkül). A statikus fájlok,
        az órarend, a naptár, a beállítások és az állapot-végpontok nem kerülnek bele.
      </p>
      <div class="hnp-cimkek"><code *ngFor="let u of allapot.figyelt_utvonalak">{{ u }}</code></div>
      <p class="hnp-halvany hnp-kicsi">
        Kiírásra vár: {{ allapot.sorban }} · indulás óta kiírva: {{ allapot.kiirt }}{{ allapot.utolsoKiiras ? ' · utolsó kiírás: ' + (allapot.utolsoKiiras | slice:0:19) : '' }}
      </p>
    </div>
  </section>
</div>
